import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { Field, reduxForm, change as changeFieldValue } from "redux-form";
import { ADMINISTRATOR, FINTECH } from "../../../../../utils/Roles";
import userHasAccess from "../../../../../utils/userHasAccess";
import validationUtils from "../../../../../utils/ValidationUtils";
import { MessageBox } from "../../../../common";
import { SelectInput, TextInput } from "../../../../common/form";
import { getErrorString } from "../../../../common/synchronization/SynchronizationHelper";
import { FAILURE, STARTED, SUCCESS } from "../../../synchronization/enums/syncStatusTypes";
import { DANGER, SUCCESS as SUCCESS_STATUS, WARNING} from "../../enums/messageBoxTypes";
import { DIVISIONS_VALIDATION_RULES } from "./divisionsValidationRules";
import { PROVINCES } from "../../../../../utils/enums/enums";
import { EnumWrapper } from "../../../../../utils/enums";
import { bindActionCreators } from "redux";
import { ELIGIBILITY, TED_DESJARDINS } from "../../enums/synchronizationOptions";
class BasicDivisionFields extends React.Component {
	constructor(props,context) {
		super(props,context);

		this.getStatus = this.getStatus.bind(this);
	}

	getChildContext() {
		return {
			scene: this.props.scene,
		};
	}

	componentDidMount() {
		if(this.props.add === true && this.props.clientProvinceCode && this.props.clientCountryCode) {
			this.props.changeFieldValue("division", "provinceCode", this.props.clientProvinceCode);
		}
	}

    getStatus() {
        let divisionStatus = DANGER;
        let boxdivisionStatus = DANGER;
        const syncStatus = this.props.syncStatus;
		let errorStrings = [];
        if (syncStatus && Object.keys(syncStatus).length > 0) {
            switch (syncStatus.status) {
                case SUCCESS:
                    boxdivisionStatus = divisionStatus = SUCCESS_STATUS;
					break;
                case STARTED:
                    boxdivisionStatus = WARNING;
                    divisionStatus = STARTED.toLowerCase();
					break;
                case FAILURE:
                    if (syncStatus.errors && syncStatus.errors.length > 0) {
                        divisionStatus = "dangerErrors";
                        errorStrings = syncStatus.errors.map((error) =>
							getErrorString([error], this.context.intl)
						);
                    }
					break;
				default:
					break;
            }
        }
        return { divisionStatus, boxdivisionStatus, errorStrings };
    }

	render() {
		const hasAdminAccess = userHasAccess([ADMINISTRATOR,FINTECH],true);
		let {divisionStatus, boxdivisionStatus, errorStrings} = this.getStatus();
		const divisionNumber = this.props.initialValues.divisionNumber;
		const canModifyDivisionNumber = hasAdminAccess || (divisionNumber === null || divisionNumber === undefined);
		
		return (
			<form onSubmit={this.props.handleSubmit}>
				<fieldset disabled={this.props.disabled}>
					{this.props.syncStatus && <MessageBox className={`alert-${boxdivisionStatus} division-message-box`}>
						<span className="d-flex">
							<FormattedMessage id={`divisions.form.syncDisplayStatus.${divisionStatus}`} />
						</span>
						{errorStrings && errorStrings.map((error, index) => (
                                <span key={index}>
                                     <span>{error}</span>
                                    <br />
                                </span>
                        ))}
						</MessageBox>}
					<Field
						id="name"
						name="name"
						component={TextInput}
						required={true}
						type="text"
						label={<FormattedMessage id="divisions.form.name" />}
					/>
					<Field
						id="divisionNumber"
						name="divisionNumber"
						component={TextInput}
						required={true}
						disabled={!canModifyDivisionNumber}
						type="text"
						label={<FormattedMessage id="divisions.form.divisionNumber" />}
					/>
					{((hasAdminAccess && this.props.syncType === ELIGIBILITY.value) || (this.props.syncType === TED_DESJARDINS.value && !this.props.viewOnly)) && (
                        <Field
                            id="externalDivisionNumber"
                            name="externalDivisionNumber"
                            component={TextInput}
                            type="text"
                            label={<FormattedMessage id="divisions.form.externalDivisionNumber" />}
                        />
                    )}
					
					{this.props.clientCountryCode &&
						<EnumWrapper
						enum={PROVINCES}
						query={`filters=provinces.countryCode==${this.props.clientCountryCode}`}
						format="inputs"
						prop="options"
						>
						<Field
						id="provinceCode"
						name="provinceCode"
						component={SelectInput}
						required={true}
						label={<FormattedMessage id="divisions.form.province" />}
						/>
						</EnumWrapper>
					}
				</fieldset>
			</form>
		);
	}
}

BasicDivisionFields.propTypes = {
	add: PropTypes.bool,
	disabled: PropTypes.bool,
	scene: PropTypes.string,
	validation: PropTypes.object,
	handleSubmit: PropTypes.func,
	syncStatus: PropTypes.object,
	clientCountryCode: PropTypes.string,
	clientProvinceCode: PropTypes.string,
	changeFieldValue: PropTypes.func,
	divisionNumber: PropTypes.string,
	initialValues: PropTypes.object,
	syncType: PropTypes.string,
	viewOnly: PropTypes.bool
};

BasicDivisionFields.defaultProps = {
	disabled: false,
	scene: "",
};

BasicDivisionFields.contextTypes = {
	getData: PropTypes.func,
	intl: intlShape,
};

BasicDivisionFields.childContextTypes = {
	scene: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  return {
	changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
  };
}

export default connect(null, mapDispatchToProps, null, { withRef: true })(
	reduxForm({
		form: "division",
		validate: (values) =>
			validationUtils.validate(values, DIVISIONS_VALIDATION_RULES),
	})(BasicDivisionFields)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/divisions/BasicDivisionFields.js